import React from 'react';
import { trustedByData } from '../mock';

const TrustedBy = () => {
  return (
    <section className="dark-full-container" style={{ paddingTop: '80px', paddingBottom: '160px' }}>
      <div className="dark-content-container">
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '100px' }}>
          <h2 className="display-large" style={{ marginBottom: '60px', color: 'var(--brand-primary)' }}>
            {trustedByData.title}
          </h2>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '25px'
          }}>
            {trustedByData.companies.map((company, index) => (
              <div 
                key={index}
                className="ui-card reveal-scale"
                style={{
                  padding: '30px',
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-subtle)',
                  textAlign: 'center',
                  transitionDelay: `${Math.min(index, 6) * 0.06}s`
                }}
              >
                <div className="body-medium" style={{ fontWeight: 500 }}>
                  {company}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;